import enEntries from "@/data/changelog.json";
import jaOverrides from "@/data/changelog.ja.json";
import deOverrides from "@/data/changelog.de.json";

export type ChangelogEntry = {
  slug: string;
  date: string;
  month: string;
  fullDate: string;
  version?: string;
  type: string;
  category: string;
  title: string;
  description: string;
  headerImage: string;
  body: string;
};

export type LocalizedEntry = ChangelogEntry & { typeLabel: string };

const TYPE_LABELS_JA: Record<string, string> = {
  FEATURE: "新機能",
  IMPROVEMENT: "改善",
  RELEASE: "リリース",
  RETIRED: "廃止",
};

const TYPE_LABELS_DE: Record<string, string> = {
  FEATURE: "Funktion",
  IMPROVEMENT: "Verbesserung",
  RELEASE: "Veröffentlichung",
  RETIRED: "Eingestellt",
};

const isJa = (lang: string) => lang.toLowerCase().startsWith("ja");
const isDe = (lang: string) => lang.toLowerCase().startsWith("de");

export function localizeEntry(entry: ChangelogEntry, lang: string): LocalizedEntry {
  if (isDe(lang)) {
    const overrides = (deOverrides as Record<string, Partial<ChangelogEntry>>)[entry.slug] ?? {};
    return {
      ...entry,
      ...overrides,
      typeLabel: TYPE_LABELS_DE[entry.type] ?? entry.type,
    };
  }
  if (!isJa(lang)) {
    return { ...entry, typeLabel: entry.type };
  }
  const overrides = (jaOverrides as Record<string, Partial<ChangelogEntry>>)[entry.slug] ?? {};
  return {
    ...entry,
    ...overrides,
    typeLabel: TYPE_LABELS_JA[entry.type] ?? entry.type,
  };
}

export function localizeEntries(entries: ChangelogEntry[], lang: string): LocalizedEntry[] {
  return entries.map((e) => localizeEntry(e, lang));
}

export const allEntries = enEntries as ChangelogEntry[];
